<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <!-- <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="货物代码">
            <el-input
              v-model="formData.goodsNo"
              placeholder="系统自动生成"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <el-form-item label="货物名称" prop="goodsName">
            <el-input
              v-model="formData.goodsName"
              placeholder="请输入货物名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="货物英文名称">
            <el-input
              v-model="formData.goodsNameEn"
              placeholder="请输入货物英文名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="货物类型">
            <dict-select
              v-model="formData.goodsType"
              placeholder="请选择货物类型"
              default
              filterable
              :body="{ type: 'goodsType' }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="包装类型">
            <dict-select
              v-model="formData.packageType"
              placeholder="请选择包装类型"
              default
              filterable
              :body="{ type: 'packageType' }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="长（米）">
            <el-input-number
              v-model="formData.packageLength"
              placeholder="请输入长（米）"
              controls-position="right"
              style="width:100%"
              :max="21474836.47"
              :min="0"
              :step-strictly="true"
              :step="0.0001"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="宽（米）">
            <el-input-number
              v-model="formData.packageWidth"
              placeholder="请输入宽（米）"
              controls-position="right"
              style="width:100%"
              :max="21474836.47"
              :min="0"
              :step-strictly="true"
              :step="0.0001"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="高（米）">
            <el-input-number
              v-model="formData.packageHeight"
              placeholder="请输入高（米）"
              controls-position="right"
              style="width:100%"
              :max="21474836.47"
              :min="0"
              :step-strictly="true"
              :step="0.0001"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收入重量kg" prop="incomeWeight">
            <el-input-number
              v-model="formData.incomeWeight"
              placeholder="请输入收入重量kg"
              controls-position="right"
              style="width:100%"
              :max="21474836.47"
              :min="0"
              :step-strictly="true"
              :step="0.0001"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收入体积m³" prop="incomeVolume">
            <el-input-number
              v-model="formData.incomeVolume"
              placeholder="请输入收入体积m³"
              controls-position="right"
              style="width:100%"
              :max="214748.3647"
              :min="0"
              :step-strictly="true"
              :step="0.0001"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="支出重量（公斤）" prop="expenseWeight">
            <el-input-number
              v-model="formData.expenseWeight"
              placeholder="请输入支出重量（公斤）"
              controls-position="right"
              style="width:100%"
              :max="21474836.47"
              :min="0"
              :step-strictly="true"
              :step="0.0001"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="支出体积m³" prop="expenseVolume">
            <el-input-number
              v-model="formData.expenseVolume"
              placeholder="请输入支出体积m³"
              controls-position="right"
              style="width:100%"
              :max="214748.3647"
              :min="0"
              :step-strictly="true"
              :step="0.0001"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="客户物料编码">
            <el-input
              v-model="formData.custGoodsNo"
              placeholder="请输入客户物料编码"
              max="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="海关编码">
            <el-input
              v-model="formData.hsCode"
              placeholder="请输入海关编码"
              max="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="报关单号">
            <el-input
              v-model="formData.customsDeclarationNo"
              placeholder="请输入报关单号"
              max="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="单价">
            <el-input-number
              v-model="formData.price"
              placeholder="请输入单价"
              controls-position="right"
              style="width:100%"
              :max="21474836.47"
              :min="0"
              :step-strictly="true"
              :step="0.0001"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="货币名称">
            <el-input
              v-model="formData.currency"
              placeholder="请输入货币名称"
              max="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="原产国">
            <el-input
              v-model="formData.originCountry"
              placeholder="请输入原产国"
              max="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="净重">
            <el-input-number
              v-model="formData.netWeight"
              placeholder="请输入净重"
              controls-position="right"
              style="width:100%"
              :max="21474836.47"
              :min="0"
              :step-strictly="true"
              :step="0.0001"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品条码">
            <el-input
              v-model="formData.goodsBarcode"
              placeholder="请输入商品条码"
              max="50"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="备注说明" prop="goodsRemarks">
            <el-input
              clearable
              v-model="formData.goodsRemarks"
              placeholder="请输入备注说明"
              type="textarea"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="运输条件">
            <el-input
              clearable
              v-model="formData.shippingConditions"
              placeholder="请输入运输条件"
              type="textarea"
              max="500"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="规格描述">
            <el-input
              clearable
              v-model="formData.specDescription"
              placeholder="请输入规格描述"
              type="textarea"
              max="500"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="save()" type="primary" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    custGoodsCode: {
      type: String,
      default: () => '',
    },
    custCode: {
      type: String,
      default: () => '',
    },
  },
  components: {},
  data() {
    return {
      backDialogVisible: false,
      formData: { custCode: this.custCode },
      rules: {
        goodsRemarks: [
          { max: 66, message: '备注说明 字数最多为66位', trigger: 'blur' },
        ],
        goodsName: [
          { required: true, message: '请输入货物名称', trigger: 'blur' },
          { max: 33, message: '货物名称 字数最多为33位', trigger: 'blur' },
        ],
        // incomeWeight: [
        //   {
        //     required: true,
        //     message: '请输入收入重量（公斤）',
        //     trigger: 'blur',
        //   },
        // ],
        // incomeVolume: [
        //   {
        //     required: true,
        //     message: '请输入收入体积（立方）',
        //     trigger: 'blur',
        //   },
        // ],
        // expenseWeight: [
        //   {
        //     required: true,
        //     message: '请输入支出重量（公斤）',
        //     trigger: 'blur',
        //   },
        // ],
        // expenseVolume: [
        //   {
        //     required: true,
        //     message: '请输入支出体积（立方）',
        //     trigger: 'blur',
        //   },
        // ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.custGoodsCode) return
      this.$api
        .masterCustomerGoodsDetailApi({
          custGoodsCode: this.custGoodsCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)
      this.formData.custCode = this.custCode
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .masterCustomerGoodsSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
